

import { useState, useEffect } from 'react';
//import CommentBox from '../../../components/CommentBox/CommentBox';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import axios from 'axios';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Lagna.scss';
import MuhuratLink from '../../../components/MuhuratLink/MuhuratLink';
import { Link } from 'react-router-dom';
import city from '../../../city.json'

const Lagna = () => {


  const rashiDescriptions = {
  Mesha: "Mesha (Aries): Energetic, ideal for new beginnings.",
  Vrishabha: "Vrishabha (Taurus): Stable, good for wealth matters.",
  Mithuna: "Mithuna (Gemini): Communicative, best for meetings.",
  Karka: "Karka (Cancer): Emotional, suited for home affairs.",
  Simha: "Simha (Leo): Leadership, great for visibility and fame.",
  Kanya: "Kanya (Virgo): Detail-oriented, perfect for planning.",
  Tula: "Tula (Libra): Balanced, ideal for partnerships.",
  Vrischika: "Vrischika (Scorpio): Intense, good for research.",
  Dhanu: "Dhanu (Sagittarius): Spiritual, ideal for travel or study.",
  Makara: "Makara (Capricorn): Disciplined, good for long-term goals.",
  Kumbha: "Kumbha (Aquarius): Innovative, good for social reform.",
  Meena: "Meena (Pisces): Imaginative, good for creative work."
};


  const parseTime = (timeStr, baseDate = new Date()) => {
  const [raw, meridian] = timeStr.trim().split(" ");
  let [hours, minutes] = raw.split(":").map(Number);
  if (meridian?.toLowerCase() === "pm" && hours < 12) hours += 12;
  if (meridian?.toLowerCase() === "am" && hours === 12) hours = 0;

  const date = new Date(baseDate);
  date.setHours(hours, minutes, 0, 0);
  return date;
};


  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata");
 

  const [timeFormat, setTimeFormat] = useState("12"); // "12", "24", or "24Plus"

  const [lagnaData, setLagnaData] = useState([]);
  
  const [currentLagna, setCurrentLagna] = useState(null);

const [selectedLagna, setSelectedLagna] = useState(null);

       // Temporary states for user input for submit button
  const [tempDate, setTempDate] = useState(currentDate);
  const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);


  useEffect(() => {
    const fetchLagnaData = async () => {

          const formattedDate = currentDate.toISOString().split('T')[0];

      if (!location || location.trim() === '') return;
      try {
    
        const response = await axios.get(
          `https://core-c343.onrender.com/api/lagna-table?date=${formattedDate}&location=${encodeURIComponent(location)}`
        );
        setLagnaData(response.data.lagnaSchedule);


        const now = new Date();

const currentSlot = response.data.lagnaSchedule.find(({ startTime, endTime }) => {
  const start = parseTime(startTime, currentDate);
  const end = parseTime(endTime, currentDate);

  if (end < start) {
    // Handle midnight wrap
    return now >= start || now <= end;
  }

  return now >= start && now <= end;
});

setCurrentLagna(currentSlot || null);

      } catch (err) {
        console.error('API error:', err);
        
      }
    };

        const debounce = setTimeout(fetchLagnaData, 500);
    return () => clearTimeout(debounce);


  }, [currentDate, location]);

  const handlePrevDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  const handleDateInput = (e) => {
    setTempDate(new Date(e.target.value));
  };

const handleMonthClick = (monthIndex) => {
  const newDate = new Date(tempDate);
  newDate.setMonth(monthIndex);
  setTempDate(newDate);
};

const handleDayClick = (day) => {
  const newDate = new Date(tempDate);
  newDate.setDate(day);
  setTempDate(newDate);
};

const handleSubmit = () => {
  setCurrentDate(tempDate);
  setLocation(tempLocation);
};

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

const formatTime = (time, mode) => {
  if (!time || typeof time !== 'string') return "N/A";

  const [start, end] = time.split(" to ");

  const parseTime = (t) => {
    if (!t) return "N/A";
    const [hourMin, ampm] = t.trim().split(' ');
    let [hour, minute] = hourMin.split(':').map(Number);
    const isPM = ampm?.toLowerCase() === 'pm';

    if (mode === '12') {
      const suffix = isPM ? 'PM' : 'AM';
      hour = hour % 12 || 12;
      return `${hour}:${minute.toString().padStart(2, '0')} ${suffix}`;
    }

    if (mode === '24') {
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    }

    if (mode === '24Plus') {
      if (isPM && hour < 12) hour += 12;
      if (!isPM && hour === 12) hour = 0;
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    }

    return t;
  };

  return `${parseTime(start)} to ${parseTime(end)}`;
};

  const formattedDate = currentDate.toISOString().split("T")[0];
  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

  return (
    <div className="Lagna-container">
      <InnerNav />
      <div className="Lagna-content">
        <Zodiac />
        <div className="Lagna-details">
                <div className="title">Lagna Muhurat Table</div>
                {/* <div className="sub">Running Do Ghati Muhurat</div> */}
              <div className="header">
                <div className="img-details">
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW3C3Ty79k_gyPc3OD5oWmoWQk5nXn1bGIYQ&s" alt="err" />
                  <div className="right">
                    {currentLagna && (
                      <div className="now-running">
                        <h3>Currently Running Lagna:</h3>
                        <div className="muhurta-card highlight">
                          <div className="caerdds">
                            <div className="title">{currentLagna.lagnaRashi}</div>
                            <div className="subtitle">
                              Pushkara Navamsha: {currentLagna.pushkaraNavamshaTime}
                            </div>
                          </div>
                          <div className="time">
                            {formatTime(`${currentLagna.startTime} to ${currentLagna.endTime}`, timeFormat)}
                          </div>
                        </div>
                      </div>
                    )}

                  </div>
                </div>
                <div className="date-display">
                  <span className="day">{currentDate.getDate()}</span>
                  <span className="month">{readableDate}</span>
                </div>
              </div>

              <div className="controls">
                <div className="mode-toggle">
                  <button onClick={() => setTimeFormat("12")} className={timeFormat === "12" ? "active" : ""}>12 Hour</button>
                  <button onClick={() => setTimeFormat("24")} className={timeFormat === "24" ? "active" : ""}>24 Hour</button>
                  <button onClick={() => setTimeFormat("24Plus")} className={timeFormat === "24Plus" ? "active" : ""}>24 Plus</button>
                </div>

                <div className="month-grid">
                  {months.map((month, i) => (
                    <button key={i} onClick={() => handleMonthClick(i)}>{month}</button>
                  ))}
                </div>

                <div className="day-grid">
                  {Array.from({ length: 31 }, (_, i) => (
                    <button key={i} onClick={() => handleDayClick(i + 1)}>{i + 1}</button>
                  ))}
                </div>

                <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  <input
                    type="date"
                    value={tempDate.toISOString().split("T")[0]}
                    onChange={handleDateInput}
                  />
                  <button onClick={handlePrevDay}>Prev Day</button>
                  <button onClick={handleNextDay}>Next Day</button>
                  <button onClick={handleSubmit}>Submit</button>

                </div>
              </div>

<div className="muhurta-section">
  {!selectedLagna ? (
    /* ========= LIST VIEW ========= */
    <>
      <div className="muhurta-header">
        <div className="muhurta-date">
          {readableDate}, {weekDay}
        </div>
      </div>

      <div className="muhurta-columns">
        <div className="muhurta-column day">
          <span>🌅 Lagna Table Division</span>

          {lagnaData.map((item, idx) => (
            <div
              key={idx}
              className="muhurta-card orange clickable"
              onClick={() => setSelectedLagna(item)}
            >
              <div className="caerdds">
                <div className="title">{item.lagnaRashi} Lagna</div>
                <div className="subtitle">
                  Pushkara Navamsha: {item.pushkaraNavamshaTime}
                </div>
              </div>

              <div className="time">
                {formatTime(`${item.startTime} to ${item.endTime}`, timeFormat)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  ) : (
    /* ========= DETAIL VIEW ========= */
    <div className="lagna-detail-page">
      <button
        type="button"
        className="back-btn"
        onClick={() => setSelectedLagna(null)}
      >
        ← Back
      </button>

      <h2>{selectedLagna.lagnaRashi} Lagna</h2>

      <p>
        <strong>Time:</strong>{" "}
        {formatTime(
          `${selectedLagna.startTime} to ${selectedLagna.endTime}`,
          timeFormat
        )}
      </p>

      <p>
        <strong>Pushkara Navamsha:</strong>{" "}
        {selectedLagna.pushkaraNavamshaTime}
      </p>

      <p className="description">
        {rashiDescriptions[selectedLagna.lagnaRashi]}
      </p>
    </div>
  )}
</div>

            </div>

            <section className="lagna-wrapper">
      <h1 className="lagna-title">About Lagna Table</h1>
      <div className="lagna-texts">
        <p>
          In Vedic Astrology Lagna, which is also known as Uday Lagna or Rising Sign, is given the utmost importance. In Western Astrology it is known as Ascendant. Lagna is the Zodiac Sign rising at the Eastern horizon. In a Hindu day, from Sunrise to Sunrise, all twelve zodiacs or Rashis rise on the Eastern horizon in a cycle.
        </p>

        <p>
          The duration of Lagna i.e. the time one zodiac takes to cross the horizon is not same for any two locations and varies from place to place. Even for a single location duration of all Lagnas is not same.
        </p>

        <p>
          Lagna plays a crucial role in Horoscope of a person. Apart from Horoscope, Lagna is considered while fixing any Muhurat. All Muhurat timings like 
          
          <Link to="/muhurat/vivah-muhurat" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}>
            Vivah Muhurat 
          </Link>
          and 
          
          <Link to="/muhurat/griha-pravesh" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px'}}>
            Griha Pravesh Muhurat 
          </Link>
          need Lagna Shuddhi in which a fortified Lagna is chosen.
        </p>
      </div>
    </section>

            
        <MuhuratLink/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Lagna;
